export const API_PATH = '/api';
export const API_SPLIT_TREATMENTS = `${API_PATH}/split/get-treatments` as const;
export const API_SPLIT_TRACK = `${API_PATH}/split/track` as const;
export const API_USER = `${API_PATH}/user` as const;
export const API_USER_CREATE = `${API_USER}/create` as const;
export const API_USER_EXISTS = `${API_USER}/exists` as const;
export const API_PAYMENT_METHODS = `${API_PATH}/account/payment-methods` as const;
